import { useTranslation } from 'react-i18next'
import { TextLinkButton, IconCancelOutline, Text } from '@machobear/design-system'
import { InsightBlock } from '../insight-block'
import { useListingActions } from '../../../context/listing-actions'

export const NoVerification = () => {
  const { t } = useTranslation()
  const { goToVerification } = useListingActions()

  return (
    <InsightBlock testId="verify-listing" icon={<IconCancelOutline tone="tertiary" size="small" />}>
      <Text>
        <TextLinkButton onClick={goToVerification} weight="regular">
          {t('Verify your listing')}
        </TextLinkButton>
      </Text>
      <Text>{t('Get 5x more engagement than unverified listings')}</Text>
    </InsightBlock>
  )
}
